import { NgModule } from "@angular/core";

import { BitIconComponent } from "./icon.component";

@NgModule({
  imports: [BitIconComponent],
  exports: [BitIconComponent],
})
export class IconModule {}
